import React, { useEffect, useState } from "react";
import { Card, Typography } from "antd";
import {
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  Legend,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { ArrowUpFromLine, ChartScatter } from "lucide-react";
import { FONT } from "constants/index";
import useBreakpoint from "hooks/useBreakpoint";

const data = [
  { area: "FISICOMOTOR", progresso: 25 },
  { area: "COGNITIVO", progresso: 10 },
  { area: "AFETIVO", progresso: 15 },
  { area: "SOCIAL", progresso: 5 },
];
const { Text } = Typography;

const ProgressoRadarChart = ({ taskDone = [], phases = [] }) => {
  const { isMobile, width } = useBreakpoint();
  const [data, setData] = useState([]);
  useEffect(() => {
    const progress = calcularProgressoPorCategoria(phases, taskDone);
    setData(progress);
  }, [taskDone, phases]);

  function calcularProgressoPorCategoria(jsonFases, tasksDone) {
    const categorias = {};

    for (const fase of jsonFases) {
      for (const sub of fase.subphases) {
        for (const objetivo of sub.objectives) {
          const cat = objetivo.category.toUpperCase();
          if (!categorias[cat]) {
            categorias[cat] = { total: 0, done: 0 };
          }

          categorias[cat].total += objetivo.tasks.length;

          for (const task of objetivo.tasks) {
            const foiFeita = tasksDone.some((t) => t.taskId === task.id);
            if (foiFeita) categorias[cat].done += 1;
          }
        }
      }
    }

    return Object.entries(categorias).map(([area, { total, done }]) => ({
      area,
      progresso: Math.round((done / total) * 100),
    }));
  }
  return (
    <Card
      title={
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ flex: 1 }}>
            <ChartScatter
              size={18}
              style={{ marginBottom: "-4px", marginRight: "10px" }}
            />
            <Text style={{ fontSize: "14px", fontFamily: FONT }}>
              Distribuição percentual por área (alvo atual)
            </Text>
          </div>
        </div>
      }
      style={{ width: "100%" }}
    >
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          fontFamily: FONT,
          fontWeight: 400,
        }}
      >
        <div style={{ flex: 1 }}>
          <ResponsiveContainer
            width="100%"
            height={isMobile ? 400 : 600}
          >
            <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data}>
              <PolarGrid />
              <PolarAngleAxis dataKey="area" />
              <PolarRadiusAxis domain={[0, 100]} />
              <Radar
                name="Desenvolvimento"
                dataKey="progresso"
                stroke="#03DAC6"
                fill="#03DAC6"
                fillOpacity={0.6}
              />
              <Tooltip />
              <Legend
                verticalAlign="top"
                height={36}
                wrapperStyle={{ top: -10 }}
                iconType="circle"
              />{" "}
            </RadarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </Card>
  );
};

export default ProgressoRadarChart;
